import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/shared/constants/routes'
import { FEATURE_FLAGS } from '@/shared/constants/feature-flags'
import type { FeatureFlag } from '@/shared/constants/feature-flags'
import { useFeatureFilter } from '@/shared/hooks/use-feature-enabled'
import { useActiveNavIndex } from '@/shared/hooks/use-active-nav-index'

export interface SideNavItem {
  to: string
  label: string
  testId: string
  flag?: FeatureFlag
}

const ITEM_STEP_REM = 3

export function useSideNav() {
  const { t } = useTranslation()

  const items = useFeatureFilter<SideNavItem>([
    {
      to: ROUTES.HOME,
      label: t('nav.dashboard'),
      testId: 'side-nav-dashboard',
      flag: FEATURE_FLAGS.WEB_APP_DASHBOARD,
    },
    {
      to: ROUTES.PET,
      label: t('nav.pet'),
      testId: 'side-nav-pet',
      flag: FEATURE_FLAGS.WEB_APP_PET,
    },
    {
      to: ROUTES.RENTERS,
      label: t('nav.renters'),
      testId: 'side-nav-renters',
      flag: FEATURE_FLAGS.WEB_APP_RENTERS,
    },
    {
      to: ROUTES.CLAIMS,
      label: t('nav.claims'),
      testId: 'side-nav-claims',
      flag: FEATURE_FLAGS.WEB_APP_CLAIMS,
    },
    {
      to: ROUTES.PERKS,
      label: t('nav.perks'),
      testId: 'side-nav-perks',
      flag: FEATURE_FLAGS.WEB_APP_PERKS,
    },
    {
      to: ROUTES.GOALS,
      label: t('nav.goals'),
      testId: 'side-nav-goals',
      flag: FEATURE_FLAGS.WEB_APP_GOALS,
    },
  ])

  const activeIndex = useActiveNavIndex(items)

  const indicatorStyle = {
    transform: `translateY(${Math.max(activeIndex, 0) * ITEM_STEP_REM}rem)`,
  }

  return {
    items,
    ariaLabel: t('nav.ariaLabel'),
    hasActive: activeIndex !== -1,
    indicatorStyle,
  }
}
